import { render, staticRenderFns } from "./UiBrackets.vue?vue&type=template&id=126435c6&"
import script from "./UiBrackets.vue?vue&type=script&lang=js&"
export * from "./UiBrackets.vue?vue&type=script&lang=js&"
import style0 from "./UiBrackets.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports